//
// This defines the default "mode" attribute used by the MFE initiualization
//
const LIFECYCLE_TO_MODE: Record<string, string> = {
  businessWebExistingCustomerInlife: 'multiedit',
  existingCustomerInlifeMaintenance: 'multiedit',
  existingCustomerPartnerServiceMaintenance: 'multiedit',
  existingCustomerTvPackMaintenance: 'multiedit',
  inlifeEventConsentMaintenance: 'multiedit',
};

export const lifecycleToMode = (lifecycle: string) => LIFECYCLE_TO_MODE[lifecycle] || '';
